import { faReact, faAndroid, faApple, faLaravel } from '@fortawesome/free-brands-svg-icons';
import { faUser, faCode } from '@fortawesome/pro-solid-svg-icons';

export default (section) => {
  console.log(section);
  switch (section) {
    case 'android':
      return faAndroid;
    case 'ios':
      return faApple;
    case 'react':
      return faReact;
    case 'laravel':
      return faLaravel;
    case 'misc':
      return faUser;
    case 'dev':
      return faCode;
    default:
      return null;
  }
};
